exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".index-module__cards___rEENn{display:grid;row-gap:.5rem;cursor:pointer;background:#fff;border-radius:5px;padding:1rem}.index-module__cards___rEENn .index-module__title___17HSa{font-weight:500;color:#1e265c;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;text-overflow:ellipsis;display:-webkit-box}@media (max-width:525px){.index-module__cards___rEENn .index-module__title___17HSa{max-width:50rem;font-size:20px}}@media (min-width:1325px){.index-module__cards___rEENn .index-module__title___17HSa{max-width:20rem;font-size:20px}}.index-module__cards___rEENn .index-module__date___3jwA3{font-size:18px;font-weight:700;color:#707070;padding-top:0;color:#169ab5}", ""]);

// exports
exports.locals = {
	"cards": "index-module__cards___rEENn",
	"title": "index-module__title___17HSa",
	"date": "index-module__date___3jwA3"
};